import React from 'react'
import PropTypes from 'prop-types'

const OnLineErrors = ({ text }) => (<span style={{color:'red'}}> {text} </span>);

OnLineErrors.prototype={
    text: PropTypes.string.isRequired
};

export default OnLineErrors;